module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('b-button', {
    attrs: {
      "to": {
        name: _vm.isUpdate ? 'app-list' : 'service-list',
        params: {
          serviceCode: _vm.$route.params.serviceCode
        }
      },
      "size": "sm",
      "variant": "link"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.caption))]), _vm._v(" 实例\n    ")], 1), _vm._v(" "), _c('b-form', {
    on: {
      "submit": _vm.onSubmit,
      "reset": _vm.onReset
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "服务名",
      "label-for": "service_code"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "service_code",
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.service_code),
      callback: function($$v) {
        _vm.$set(_vm.data, "service_code", $$v)
      },
      expression: "data.service_code"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "实例代号",
      "label-for": "code"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "code",
      "type": "text",
      "disabled": _vm.isUpdate,
      "required": ""
    },
    model: {
      value: (_vm.data.code),
      callback: function($$v) {
        _vm.$set(_vm.data, "code", $$v)
      },
      expression: "data.code"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "产品",
      "label-for": "product_code"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "product_code",
      "options": _vm.products,
      "text-field": "name",
      "value-field": "code",
      "disabled": _vm.isUpdate,
      "required": ""
    },
    model: {
      value: (_vm.data.product_code),
      callback: function($$v) {
        _vm.$set(_vm.data, "product_code", $$v)
      },
      expression: "data.product_code"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label-for": "tags",
      "label": "标签："
    }
  }, [_c('el-select', {
    staticClass: "mb-2",
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "default-first-option": "",
      "id": "tags",
      "placeholder": "选择或输入，按回车键确认"
    },
    model: {
      value: (_vm.data.tags),
      callback: function($$v) {
        _vm.$set(_vm.data, "tags", $$v)
      },
      expression: "data.tags"
    }
  }, _vm._l((_vm.allTags), function(tag) {
    return _c('el-option', {
      key: tag.value,
      attrs: {
        "label": tag.text,
        "value": tag.value
      }
    })
  }), 1)], 1), _vm._v(" "), (!_vm.hasTemplate) ? [_c('b-form-group', [_vm._v("\n          暂无描述模板，"), _c('router-link', {
    attrs: {
      "to": {
        name: 'template-edit'
      }
    }
  }, [_vm._v("点击")]), _vm._v("前往配置\n        ")], 1)] : [_c('b-form-group', {
    attrs: {
      "label": "实例信息",
      "label-for": "descs",
      "label-class": "font-weight-bold"
    }
  }, [_c('b-card', [_c('confnode', {
    attrs: {
      "useDefault": true,
      "items": _vm.data.descs,
      "userPerm": _vm.userPerm(),
      "strict": true
    }
  })], 1)], 1), _vm._v(" "), (!_vm.isUpdate) ? _c('b-form-group', {
    attrs: {
      "label": "创建实例参数配置",
      "label-for": "create",
      "label-class": "font-weight-bold"
    }
  }, [_c('b-card', [_c('confnode', {
    attrs: {
      "useDefault": true,
      "items": _vm.data.create,
      "userPerm": _vm.userPerm(),
      "strict": true
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-form-group', [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('label', {
    staticClass: "font-weight-bold"
  }, [_vm._v("实例配置")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }), _vm._v(" "), _c('b-col', [_c('b-form-select', {
    attrs: {
      "id": "confs_history",
      "options": _vm.confsHistory
    },
    on: {
      "change": _vm.changeConf
    },
    model: {
      value: (_vm.selectedConf),
      callback: function($$v) {
        _vm.selectedConf = $$v
      },
      expression: "selectedConf"
    }
  })], 1)], 1), _vm._v(" "), _c('b-card', [(_vm.isUpdate) ? _c('confnode', {
    attrs: {
      "items": _vm.data.confs,
      "userPerm": _vm.userPerm(),
      "strict": true
    },
    on: {
      "update:items": function($event) {
        return _vm.$set(_vm.data, "confs", $event)
      }
    }
  }) : _c('confnode', {
    attrs: {
      "useDefault": true,
      "items": _vm.data.confs,
      "userPerm": _vm.userPerm(),
      "strict": true
    },
    on: {
      "update:items": function($event) {
        return _vm.$set(_vm.data, "confs", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), (_vm.isUpdate && Object.keys(_vm.data.interfaces).length > 0) ? _c('b-form-group', {
    attrs: {
      "label": "接口信息",
      "label-class": "font-weight-bold"
    }
  }, [_c('b-card', [(_vm.tabShow) ? _c('AppTab', {
    attrs: {
      "items": _vm.data.interfaces,
      "notData": true
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isUpdate && Object.keys(_vm.data.stats).length > 0) ? _c('b-form-group', {
    attrs: {
      "label": "统计接口",
      "label-class": "font-weight-bold"
    }
  }, [(_vm.tabShow) ? _c('AppTab', {
    attrs: {
      "items": _vm.data.stats,
      "notData": true
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isUpdate && Object.keys(_vm.data.checks).length > 0) ? _c('b-form-group', {
    attrs: {
      "label": "心跳检查",
      "label-class": "font-weight-bold"
    }
  }, [(_vm.tabShow) ? _c('AppTab', {
    attrs: {
      "items": _vm.data.checks,
      "notData": true
    }
  }) : _vm._e()], 1) : _vm._e()], _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    staticClass: "footer-btn",
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "outline-primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload"
  }), _vm._v(" 提交")]), _vm._v(" "), _c('b-button', {
    staticClass: "footer-btn back-btn",
    attrs: {
      "type": "reset",
      "size": "sm",
      "variant": "outline-secondary"
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" 返回")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4758301c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/AppUpdate.vue
// module id = /S06
// module chunks = 4